import { render, staticRenderFns } from "./blank-page.vue?vue&type=template&id=74ef7705&scoped=true"
import script from "./blank-page.vue?vue&type=script&lang=js"
export * from "./blank-page.vue?vue&type=script&lang=js"
import style0 from "./blank-page.vue?vue&type=style&index=0&id=74ef7705&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ef7705",
  null
  
)

export default component.exports